import { DatePicker } from "antd";

import React, { createContext, useContext } from "react";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import { observer } from "mobx-react-lite";
import WizardStore from "../store/wizardstore";
import { getPickerDate, toAntPickerDate } from "../../../Utility/modules/datePicker";
const wizardStoreCtx = createContext(WizardStore);
export const UploadDateSelect = observer(() => {
  const wizardStore = useContext(wizardStoreCtx);
  return (
    <>
      <SubPageHeaderTitle title="Field Production Date" />
      <div
        style={{
          display: "flex",
          height: "60vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="ms-Grid" dir="ltr" style={{ width: "100%" }}>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">Select Production Date </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              {" "}
              <DatePicker
                style={{ width: "80%" }}
                value={toAntPickerDate(wizardStore.productionDate)}
                onChange={(date, datesting) => {
                  if (date) {
                    wizardStore.productionDate = getPickerDate(date);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

